<template>
    <div class="two-step">
        <div class="two-step-header">
            <div class="autodesk-logo-header">
                <img class="autodesk-logo" src="../assets/images/employeehub-logo.svg" @click="navigateToHome()"/>
            </div>
        </div>
        <two-step-body/>
        <two-step-footer/>
    </div>

</template>

<script>
    import TwoStepBody from '@/components/TwoStepBody.vue'
    import TwoStepFooter from "./TwoStepFooter"
    import MixpanelMixin from "@/mixins/MixpanelMixin";

    export default {
        name: 'two-step',
        mixins: [MixpanelMixin],
        components: {
            TwoStepFooter,
            TwoStepBody
        },
        mounted() {
            this.trackEvent("Page Hit: Employee Hub Two-step verification");
        },
        methods: {
            navigateToHome() {
                location.href = process.env.VUE_APP_LANDING_PAGE_API;
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .autodesk-logo-header{
        height: min-content;
        margin-bottom: 0;
        border-radius: 0;
        min-height: 60px;
        padding-right: 28px;
        padding-left: 28px;
        
        border: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .two-step {
        min-width: 315px;
    }
    .two-step-header {
        background-color: #000000;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .container-fluid {
        padding-right: 0;
    }
</style>
